<template>
  <div class="result w-full bg-white">
    <div class="tabs flex border-b border-[#c3c3c3]">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        type="button"
        class="w-1/2 py-3 text-base font-semibold border-b-2"
        :class="activeTab === tab.value ? 'text-primary border-primary' : 'text-[#979797] border-transparent'"
        @click="activeTab = tab.value"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="px-4 py-6">
      <h1 class="font-semibold text-2xl mb-3">
        {{ pageTitle }}
      </h1>
      <p class="text-base my-3">{{ pageDescription }}</p>

      <div v-for="(item, index) in diseaseList" :key="`itemList-${index}`" class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">{{ item.title }}</p>
          <Checked v-if="item.isChecked" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
    </div>

    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  computed, ref,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import Loading from '@/components/LoadingOverlay.vue';
import Checked from '@/components/icons/Checked.vue';
import Unchecked from '@/components/icons/Unchecked.vue';

const store = useStore();
const route = useRoute();

const tabs = [
  {
    label: 'Keluarga',
    value: 'family',
  },
  {
    label: 'Pribadi',
    value: 'individual',
  },
];

const familyDiseaseFields = [
  {
    title: 'Diabetes Melitus',
    key: 'isHadDiabetes',
  },
  {
    title: 'Tekanan Darah Rendah',
    key: 'isHadHypotension',
  },
  {
    title: 'Tekanan Darah Tinggi',
    key: 'isHadHypertension',
  },
  {
    title: 'Penyakit Jantung',
    key: 'isHadHeartDisease',
  },
  {
    title: 'Penyakit Paru-Paru',
    key: 'isHadLungDisease',
  },
  {
    title: 'Kanker',
    key: 'isHadCancer',
  },
  {
    title: 'Stroke',
    key: 'isHadStroke',
  },
];

const individualDiseaseFields = [
  {
    title: 'Diabetes Melitus',
    key: 'isHadDiabetes',
  },
  {
    title: 'Tekanan Darah Tinggi',
    key: 'isHadHypertension',
  },
  {
    title: 'Stroke',
    key: 'isHadStroke',
  },
  {
    title: 'Penyakit Jantung',
    key: 'isHadHeartDisease',
  },
  {
    title: 'Asma',
    key: 'isHadAsthma',
  },
  {
    title: 'Kanker',
    key: 'isHadCancer',
  },
  {
    title: 'Kolesterol Tinggi',
    key: 'isHadHighCholesterol',
  },
];

const activeTab = ref('family');

const loading = computed(() => store.state.global.loading);
const hereditary = computed(() => store.state.screening.hereditary);
const individualDisease = computed(() => store.state.screening.individualDisease);

const pageTitle = computed(() => (activeTab.value === 'family' ? 'Riwayat Keluarga' : 'Riwayat Individu'));
const pageDescription = computed(() => (activeTab.value === 'family' ? 'Berikut adalah riwayat penyakit keluarga Anda' : 'Berikut adalah riwayat penyakit individu Anda'));
const diseaseFields = computed(() => (activeTab.value === 'family' ? familyDiseaseFields : individualDiseaseFields));
const diseaseSource = computed(() => (activeTab.value === 'family' ? hereditary.value : individualDisease.value));

const diseaseList = computed(() => diseaseFields.value.map((item) => ({
  title: item.title,
  isChecked: diseaseSource.value?.[item.key],
})));

async function getHereditaryData() {
  await store.dispatch('screening/getHereditaryDisease', {
    token: route.query.token,
    dob: store.state.global.dob,
  });
}

async function getIndividualDiseaseData() {
  await store.dispatch('screening/getIndividualDisease', {
    token: route.query.token,
    dob: store.state.global.dob,
  });
}

getHereditaryData();
getIndividualDiseaseData();

</script>

<script>
export default {
  name: 'FamilyHistoryView',
};
</script>

<style lang="scss" scoped>
</style>
